// reducer.js
import {
  SET_VALUE_ModeleLoyer,
  SET_TYPE_ModeleLoyer,
  SET_CURRENT_PAGE_ModeleLoyer,
  SET_ORDER_ModeleLoyer,
  SET_SORT_FIELD_ModeleLoyer,
  SET_ACTIF_ModeleLoyer,
  SET_CATEGORIE_ModeleLoyer,
} from "./actionsTypes";

const initialState = {
  value: "",
  type: "",
  actif: "",
  currentPage: 1,
  order: "desc",
  sortField: "cree_le",
  categorie: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_ModeleLoyer:
      return {
        ...state,
        value: action.payload,
      };
    case SET_CATEGORIE_ModeleLoyer:
      return {
        ...state,
        categorie: action.payload,
      };
    case SET_TYPE_ModeleLoyer:
      return {
        ...state,
        type: action.payload,
      };

    case SET_CURRENT_PAGE_ModeleLoyer:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_ModeleLoyer:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_ModeleLoyer:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_ACTIF_ModeleLoyer:
      return {
        ...state,
        actif: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
